module.exports = __webpack_public_path__ + "img/icon-refund-applied.e3819efb.svg";